import { thor } from "../../../typings/thor";

export class MediaGallerySidenavUploadMediaDialogController {
    public static $inject: string[] = [
        "$log",
        "$mdDialog",
        "$mdMedia",
        "$translate",
        "mediaGallerySidenavUploadMediaService"
    ];

    public name: string;
    public steps: Array<Object>;
    public reports: Array<Object>;
    public gauges;
    public state;
    public isBusy: boolean = false;
    public progress;

    // Binded
    private files: File[];
    private resource: thor.ItemGet;

    private $t;

    constructor(
        private $log: ng.ILogService,
        private $mdDialog: ng.material.IDialogService,
        public $mdMedia: ng.material.IMedia,
        $translate: ng.translate.ITranslateService,
        private mediaGallerySidenavUploadMediaService
    ) {
        this.$t = $translate.instant;

        this.name = this.$t("importation");
        this.steps = [];
        this.reports = [];

        this.gauges = {
            medias: {
                created: 0,
                errors: 0,
                total: 0
            }
        };

        this.state = {
            warning: false,
            error: false
        };

        this.progress = 0;

        this.engine();
    }

    public finish() {
        if (this.isBusy) {
            return;
        }
        this.$mdDialog.hide(this.name);
    }

    private engine() {
        if (this.files) {
            this.addStepDone(this.$t("fichiers_valides"));
            this.addStepDone(this.$t("import_a_partir_de_photos"));

            this.gauges.medias.total = this.files.length;
            this.isBusy = true;

            this.mediaGallerySidenavUploadMediaService.engine(this.resource, this.files)
                .then(() => {
                    this.addStepDone(this.$t("import_termine"));
                })
                .catch(error => {
                    this.$log.error("Error while importing media", error);
                    this.addStepError(this.$t("erreur_lors_de_l_import_d_images"));
                })
                .finally(
                    () => {
                        this.isBusy = false;
                    },
                    notification => {
                        this.onNotify(notification);
                    }
                );
        }
    }

    private onNotify(notification) {
        switch (notification.action) {
            case "incrementGauge":
                this.incrementGauge(notification.data);
                break;
            case "setGauge":
                this.setGauge(notification.data);
                break;
            case "addStepDone":
                this.addStepDone(notification.data);
                break;
            case "addStepError":
                this.addStepError(notification.data);
                break;
            case "addReportWarning":
                this.addReportWarning(notification.data);
                break;
            case "addReportError":
                this.addReportError(notification.data);
                break;
            default:
                this.$log.error(`onNotify:: action: ${notification.action} is not implemented`);
                break;
        }
    }

    private incrementGauge(data) {
        const increment = data.increment || 1;
        switch (data.key) {
            case "mediasCreated":
                this.gauges.medias.created += increment;
                break;
            case "mediasErrors":
                this.gauges.medias.errors += increment;
                break;
            case "mediasTotal":
                this.gauges.medias.total += increment;
                break;
            default:
                this.$log.error(`Gauge type : ${data.key} is not implemented`);
                break;
        }
        this.updateProgress();
    }

    private setGauge(data) {
        switch (data.key) {
            case "itemsTotal":
                this.gauges.items.total = data.value;
                break;
            case "extraItemsTotal":
                this.gauges.extraItems.total = data.value;
                break;
            default:
                this.$log.error(`Gauge type : ${data.key} is not implemented`);
                break;
        }
        this.updateProgress();
    }

    private updateProgress() {
        const denominator = this.gauges.medias.total;
        const numerator = this.gauges.medias.created + this.gauges.medias.errors;

        let progress = Math.ceil(100 * numerator / denominator);
        if (progress > 100) { progress = 100; }
        this.progress = progress;
    }

    private addStepDone(title) {
        this.addStep({
            status: "done",
            title: title
        });
    }

    private addStepError(title) {
        this.addStep({
            status: "error",
            title: title
        });
    }

    private addReportWarning(title) {
        this.addReport({
            level: "warning",
            title: title
        });
        if (!this.state.warning) {
            this.state.warning = true;
        }
    }

    private addReportError(title) {
        this.addReport({
            level: "error",
            title: title
        });
        if (!this.state.error) {
            this.state.error = true;
        }
    }

    private addStep(step) {
        this.steps.push(step);
    }

    private addReport(report) {
        this.reports.push(report);
    }
}
